import React, { CSSProperties, SyntheticEvent, useMemo, useState } from "react";

import { ButtonProps } from "semantic-ui-react";

import { ADMIN_NAME_LIST } from "react-lib/apps/USER/CardSettingDivision";

import CardEmployeeInfoManagementUX from "./CardEmployeeInfoManagementUX";
import CardEmployeeList from "./CardEmployeeList";
import CardEmployeeProfile from "./CardEmployeeProfile";
import CardEmployeeSummaryWorkHour from "./CardEmployeeSummaryWorkHour";
import CardEmployeeTimeAttendance from "./CardEmployeeTimeAttendance";

import { PickedState } from "./HRMInterface";

type CardEmployeeInfoManagementProps = Pick<
  PickedState,
  "adminMenuDivisions" | "selectedDivision"
> & {
  onEvent: (e: any) => any;
  setProp: (key: string, value: any, callback?: () => void) => any;
  runSequence: any;
  DSPermissionSequence: any;
  EmployeeDocumentSequence: any;
  EmployeeHistorySequence: any;
  EmployeeInfoSequence: any;
  EmployeeListSequence: any;
  EmployeePaymentSequence: any;
  EmployeeSWHSequence: any;
  EmployeeTASequence: any;
  changePassword: any;
  allDivisionGroup: any;
  buttonLoadCheck: any;
  django?: any;
  errorMessage: any;
  languageUX: string;
  masterData: any;
  masterOptions: any;
  searchedItemListWithKey: any;
  selectedEmployee: any;
  successMessage: any;
};

type TabTypes = "EMPLOYEE_LIST" | "EMPLOYEE_SWH" | "EMPLOYEE_TA";

type Styles = Record<"summaryWorkHour" | "timeAttendance", CSSProperties>;

const styles: Styles = {
  summaryWorkHour: { marginTop: "-1.75rem" },
  timeAttendance: { marginTop: "-1.75rem" },
};

const CardEmployeeInfoManagement = (props: CardEmployeeInfoManagementProps) => {
  const [tab, setTab] = useState<TabTypes>("EMPLOYEE_LIST");
  const [openEmployeeProfile, setOpenEmployeeProfile] = useState<boolean>(false);
  const [selectedEmployee, setSelectedEmployee] = useState<Record<string, any> | null>(null);

  const filteredTabMenu = useMemo(() => {
    const roleTypes: string[] = props.django?.user?.role_types || [];
    const isHR = roleTypes.includes("HR");

    // กรณีเป็น role type อื่น จะแสดง แค่ Employee Lists
    return isHR ? ["EMPLOYEE_LIST", "EMPLOYEE_SWH", "EMPLOYEE_TA"] : ["EMPLOYEE_LIST"];
  }, [props.django]);

  const divisionOptions = useMemo(
    () => props.adminMenuDivisions?.all[ADMIN_NAME_LIST.ข้อมูลบุคลากร]?.divisions ?? [],
    [props.adminMenuDivisions]
  );

  const handleChangeTab = (e: SyntheticEvent, data: ButtonProps) => {
    setTab(data.name);
  };

  const handleAddEmployee = () => {
    setOpenEmployeeProfile(true);
  };

  const handleSelectEmployee = (data: any) => {
    setSelectedEmployee(data);

    setOpenEmployeeProfile(true);
  };

  const handleGoBack = () => {
    setSelectedEmployee(null);
    setOpenEmployeeProfile(false);
  };

  return (
    <div>
      {openEmployeeProfile ? (
        <CardEmployeeProfile
          onEvent={props.onEvent}
          setProp={props.setProp}
          runSequence={props.runSequence}
          DSPermissionSequence={props.DSPermissionSequence}
          EmployeeDocumentSequence={props.EmployeeDocumentSequence}
          EmployeeHistorySequence={props.EmployeeHistorySequence}
          EmployeeInfoSequence={props.EmployeeInfoSequence}
          EmployeePaymentSequence={props.EmployeePaymentSequence}
          changePassword={props.changePassword}
          employeeId={selectedEmployee?.id}
          userId={selectedEmployee?.user_employee?.[0]?.id}
          adminMenuDivisions={props.adminMenuDivisions}
          allDivisionGroup={props.allDivisionGroup}
          buttonLoadCheck={props.buttonLoadCheck}
          django={props.django}
          errorMessage={props.errorMessage}
          languageUX={props.languageUX}
          masterData={props.masterData}
          masterOptions={props.masterOptions}
          selectedDivision={props.selectedDivision}
          selectedEmployee={props.selectedEmployee}
          successMessage={props.successMessage}
          onGoBack={handleGoBack}
        />
      ) : (
        <>
          <CardEmployeeInfoManagementUX
            filteredTabMenu={filteredTabMenu}
            tab={tab}
            onChangeTab={handleChangeTab}
          />

          {tab === "EMPLOYEE_LIST" && (
            <CardEmployeeList
              setProp={props.setProp}
              runSequence={props.runSequence}
              EmployeeListSequence={props.EmployeeListSequence}
              buttonLoadCheck={props.buttonLoadCheck}
              languageUX={props.languageUX}
              masterData={props.masterData}
              masterOptions={props.masterOptions}
              onAddEmployee={handleAddEmployee}
              onSelectEmployee={handleSelectEmployee}
            />
          )}

          {tab === "EMPLOYEE_SWH" && (
            <CardEmployeeSummaryWorkHour
              setProp={props.setProp}
              runSequence={props.runSequence}
              EmployeeSWHSequence={props.EmployeeSWHSequence}
              style={styles.summaryWorkHour}
              readOnly
              buttonLoadCheck={props.buttonLoadCheck}
              errorMessage={props.errorMessage}
              languageUX={props.languageUX}
              divisionOptions={divisionOptions}
            />
          )}

          {tab === "EMPLOYEE_TA" && (
            <CardEmployeeTimeAttendance
              onEvent={props.onEvent}
              setProp={props.setProp}
              runSequence={props.runSequence}
              EmployeeTASequence={props.EmployeeTASequence}
              style={styles.timeAttendance}
              buttonLoadCheck={props.buttonLoadCheck}
              masterOptions={props.masterOptions}
              searchedItemListWithKey={props.searchedItemListWithKey}
              divisionOptions={divisionOptions}
            />
          )}
        </>
      )}
    </div>
  );
};

CardEmployeeInfoManagement.displayName = "CardEmployeeInfoManagement";

export default React.memo(CardEmployeeInfoManagement);
